{
    "actions": {
        "page": {
            "add_merchant_user": "New merchant user",
            "delete_multiple_contracts": "Delete contracts",
            "add_external_contract": "Create external contract"
        }
    },
    "filter": {
        "placeholder": {
            "email": "Filter by email",
            "label": "Filter by label"
        }
    },
    "keys": {
        "status": "Status",
        "email": "Email",
        "last_login_at": "Connected at",
        "profile": "Profile",
        "created_at": "Created at",
        "updated_at": "Updated at"
    },
    "modal": {
        "add_external_contract": {
            "title": "Create an external contract",
            "title1": "Create {{externalContractName}} contract",
            "title2": "New contract for {{merchantName}}",
            "alma": {
                "api_key": "API key",
                "pos_ticket_label": "POS Terminal ticket label",
                "pos_ticket_label_indication": "(Unique and linked to the contract - Special characters and accents not allowed)",
                "pos_ticket_label_placeholder": "12 characters max.",
                "success": "API key validated successfully!"
            },
            "cbvad": {
                "contract_label": "Label",
                "contract_type": "Contract type",
                "contract_number": "Contract #",
                "rank": "Rank",
                "bank_code": "Bank code",
                "x25_address": "Remote configuration center address",
                "success": "Contract added successfully!",
                "select": {
                    "contract_type": {
                        "placeholder": "Select contract type",
                        "CONTACT": "Proximity Contact",
                        "CONTACTLESS": "Proximity Contactless",
                        "VAD": "Proximity VAD",
                        "CONTACT_AUTOMATE": "Automate Contact",
                        "CONTACTLESS_AUTOMATE": "Automate Contactless"
                    }
                },
                "errors": {
                    "REMOTE_CONFIGURATION_ERROR": "The remote configuration of the contract has failed",
                    "ALREADY_EXISTS": "The contract already exists",
                    "UNKNOWN_ERROR": "An unknown error occurred."
                }
            }
        },
        "add_merchant_user": {
            "title": "New merchant user",
            "success": "Merchant user added successfully!",
            "text": "A download link will be sent to the user's email address.",
            "info": "The link will be valid for 48 hours.",
            "maximum_mails": "(5 mails maximum)",
            "placeholder": "Enter email here...",
            "already_exists": "This mail alreay exists !",
            "confirmation": "Mail will be sent to the following recipient:",
            "confirmation_users": "Mail will be sent to the following recipients:",
            "validate": "Validate to finish",
            "add_address": "Add address",
            "remove_address": "Remove address"
        }
    },
    "profile": {
        "PROFILE_ADMIN_MERCHANT": "Admin.",
        "PROFILE_STANDARD": "Standard",
        "PROFILE_ADMIN_MERCHANT_main": "Admin. (Main)",
        "PROFILE_STANDARD_main": "Standard (Main)"
    },
    "status": {
        "ACTIVE": "Activated",
        "INACTIVE": "Disactivated"
    }
}